export default __webpack_public_path__ + "static/media/img-sideface.93dff430.svg";